var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEmptyCart = function SvgIconEmptyCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 105,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    y: 0.5,
    rx: 52
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M42.01 44.499v-4c0-5.523 4.477-10 10-10s10 4.477 10 10v4h6a2 2 0 0 1 2 2v24a2 2 0 0 1-2 2h-32a2 2 0 0 1-2-2v-24a2 2 0 0 1 2-2zm0 4h-4v20h28v-20h-4v4h-4v-4h-12v4h-4zm4-4h12v-4a6 6 0 0 0-12 0z"
  })));
};
export default SvgIconEmptyCart;